__turbopack_context__.v({
  "hr": "_5UqsJa_hr",
  "link": "_5UqsJa_link",
  "ribbonOpen": "_5UqsJa_ribbonOpen",
  "tabletContent": "_5UqsJa_tabletContent",
  "wrapper": "_5UqsJa_wrapper",
});
